import { useState } from "react";
import { Download } from "../../svg/Download";
import { File } from "../../svg/File";
import { useGlobalContext } from "../../../context";
import environment from "environment";

import {
  RemoveBtn,
  LoadFileLink,
  SelectButton,
} from "./FileElements";

const MyFile = (props) => {
  const [hover, setHover] = useState(false);
  const { file, select, ID, folder } = props;
  const { secundaryColor } = useGlobalContext();

  const downloadFile = () => {
    const helppeopleHeaders = {
      "x-helppeople-token": localStorage.getItem("token").toString(),
    };

    if (!file.FileName || file.FileName === "") return;

    fetch(`${environment.api.url}/file/GetFile/${folder}/${ID}/${file.FileName}`, {
      method: "GET",
      headers: helppeopleHeaders,
    })
      .then((response) => {
        if (!response.ok) {
        }
        return response.blob();
      })
      .then((blob) => {
        const url = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url;

        link.setAttribute("download", file.FileName);

        document.body.appendChild(link);

        link.click();

        link.parentNode.removeChild(link);
      });
  };

  return (
    <LoadFileLink
      bg={!select && secundaryColor}
      rel="noreferrer"
      className={`w-4/6 sm:w-full h-52 flex flex-col py-8 gap-6 bg-white border border-1 border-gray rounded-lg justify-center items-center`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onClick={downloadFile}
    >
      {hover && (
        <span className="absolute top-0 scale-0 transition-all rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100 z-1000">
          {file.FileName}
        </span>
      )}
      <span>
        {hover && !select ? <Download size="4rem" /> : <File size="4rem" />}
      </span>
      <h1 className="w-full text-xs sm:text-sm font-title text-center px-2 break-words text-gray-600">
        {file.FileName.length >= 15
          ? file.FileName.slice(0, 10) + "..." + file.FileName.slice(-7)
          : file.FileName}
      </h1>
    </LoadFileLink>
  );
};
export default MyFile;

export const Select = () => {
  return <SelectButton />;
};

export const Remove = () => {
  return <RemoveBtn />;
};

export const FileRemoveModalContent = (props) => {
  const { list, setModalActive, eliminar } = props;
  return (
    <div className="flex flex-col gap-2">
      <div className="p-3 w-full break-words border rounded-md">
        <p>{`¿Está seguro que quiere eliminar los siguientes archivos: ${list.map(
          (item) => {
            return ` ${item.filename}`;
          }
        )}?`}</p>
      </div>
      <div className="flex justify-between py-2">
        <button
          className="bg-red-500 w-20 text-white rounded-md hover:bg-red-400 text-center border border-black"
          onClick={() => setModalActive(false)}
        >
          Cancelar
        </button>
        <button
          className="bg-green-500 w-20 text-white rounded-md hover:bg-green-400 text-center border border-black"
          onClick={() => {
            eliminar(list);
            setModalActive(false);
          }}
        >
          Eliminar
        </button>
      </div>
    </div>
  );
};
